import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	rootCtn: {
		width           : "100%",
		// paddingBottom   : "1rem",
		backgroundColor : theme.other.colors.dialog.secondary,

		"& .epr-main": {
			borderLeft   : "none !important",
			borderRight  : "none !important",
			borderRadius : "0 !important",
			zIndex       : "25 !important"

		},
		// "& .epr-header-overlay": {
		// display: "none !important"
		// },
		"& .epr-preview": {
			display: "none !important"
		},
		"& .epr-emoji-category-label": {
			fontSize   : "1.2rem",
			fontWeight : "500 !important",
			color      : "#000000 !important"
		}
	}
} ) );

